import React, { Component } from 'react';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Row, Col, Select, Input } from 'antd';

const { Option } = Select;

export default class BooleanFilter extends Component {
  valueOptions = [
    { id: 'true', label: 'Yes' },
    { id: 'false', label: 'No' }
  ];

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Row gutter={8} align="middle">
        <Col span={8}>
          <span>{this.props.label || this.props.field}</span>
        </Col>
        <Col span={16}>
          {getFieldDecorator(`${this.props.field}._field`, {
            initialValue: this.props.field
          })(<Input type="hidden" />)}
          {getFieldDecorator(`${this.props.field}.operator`, {
            initialValue: 'IS'
          })(<Input type="hidden" />)}
          <Form.Item style={{ marginBottom: 0 }}>
            {getFieldDecorator(`${this.props.field}.value`, {
              rules: []
            })(
              <Select placeholder="Select" style={{ width: '100%' }} allowClear>
                {this.valueOptions.map((item, key) => (
                  <Option key={item.id} value={item.id}>
                    {item.label}
                  </Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
      </Row>
    );
  }
}
